"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultFallback_1 = __importDefault(require("./DefaultFallback"));
/**
 * A simple, standard [React Error Boundary](https://reactjs.org/docs/error-boundaries.html) to catch, display, and report
 * errors from your application. If you're unfamiliar with them, see the linked documentation to review how they work.
 *
 * Error Boundaries can help your app to gracefully degrade when it encounters errors, i.e. displaying useful error information
 * to include when reporting errors or including a refresh/retry button.
 *
 * We also highly recommend using the `onError` prop to log errors to Sentry:
 *
 * ```jsx
 * <ErrorBoundary onError={error => sentry.captureException(error)}>
 *   ..
 * </ErrorBoundary>
 * ```
 *
 */
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }
    componentDidCatch(error, errorInfo) {
        const { onError } = this.props;
        if (onError) {
            onError(error, errorInfo);
        }
        this.setState({ error, errorInfo });
    }
    render() {
        const { error, errorInfo } = this.state;
        if (!!error) {
            const Fallback = this.props.fallback || DefaultFallback_1.default;
            return react_1.default.createElement(Fallback, { error: error, errorInfo: errorInfo });
        }
        return this.props.children;
    }
}
exports.default = ErrorBoundary;
